export default __webpack_public_path__ + "static/SpotDark-f4416aa03ec26719ce6e8af47aeb2724b771bfb0b1ae61fdbc6b53f4363892f0.png";